module.exports = __webpack_public_path__ + "static/media/03.eb915940.jpg";